import axios from "@/util/axios";

export default {
    // 设置配送员
    updateDelivery: (data) => axios.get({url: "/order/common/mini/order/updateDelivery",data: data}),
}